import React from "react";
import { FormControl, Button, Container, Flex } from "@airbus/components-react";
import eventBus from "../eventBus/EventBus";


//CSS
import "../css/Forms.css";



class EventInfoView extends React.Component {

    constructor(props){
        super();

        //States;
        let description = props.description.replace(/(<([^>]+)>)/gi, "");
        description = this.decodeHtmlCharCodes(description);

        this.state={
            form:{
                id: props.id,
                title: props.title,                   //Form handler
                start_date: props.start_date,
                end_date: props.end_date,
                date: props.date,
                description: description,
                allDay: props.allDay ,
                venue: props.venue,
            },
        }

    }

    

    /**
     * RENDERING
     */

    render(){
        return(

            <Container>
                               
                
                
                {/*TITRE*/}
                <Flex wrap={true} direction="row" >
                
                <FormControl
                    label="Titre"
                    className="controlForm"
                >
                    <div>{this.state.form.title}</div>
                    
                </FormControl>
                
                {/*START DATE*/}
                <FormControl
                    label="Début événement"
                    className="controlForm"
                >
                    
                    <div>{this.state.form.start_date}</div>
                </FormControl>
                
                
                
                {/*END DATE*/}
                <FormControl
                    label="Fin événement"
                    className="controlForm"
                >
                        
                    
                    <div>{this.state.form.end_date}</div>
                </FormControl>

                {/*DATE PUBLISH*/}
                <FormControl
                    label="Date Publication"
                    className="controlForm"
                >
                        
                    
                    <div>{this.state.form.date}</div>
                </FormControl>

                {/*ALL DAY EVENT*/}
                <FormControl
                    label="Toute la journée"
                    className="controlForm"
                >
                    <div>{this.state.form.allDay}</div>
                </FormControl>
                </Flex>

                
                {/*DESCRIPTION*/}
                <Container until="md" className="container-left" style={{paddingLeft:"0px"}}>
                <Flex wrap={true} direction="row" >
                <FormControl
                    label="Description"
                    className="FullWidthcontrolForm"
                    style={{width:772}}
                >
                    <div>{this.state.form.description}</div>
                </FormControl>
                </Flex>
                </Container>
                
               

                <Flex wrap={true} direction="row" >
                    {/*Adresse*/}
                    <FormControl
                        label="Adresse"
                        className="controlForm"
                    >
                        <div>{this.state.form.venue.address}</div>
                        
                    </FormControl>

                    {/*ZIP*/}
                    <FormControl
                        label="Code postal"
                        className="controlForm"
                    >
                        <div>{this.state.form.venue.zip}</div>
                        
                    </FormControl>

                    {/*CITY*/}
                    <FormControl
                        label="Ville"
                        className="controlForm"
                    >
                        <div>{this.state.form.venue.city}</div>
                        
                    </FormControl>
                </Flex>

                
                {/*BACK*/}
                <Container until="sm" className="container-left" style={{paddingLeft:"0px"}}>
                <Flex wrap={true} direction="row" >
                <FormControl
                        className="button-controlForm"
                    >
                <Button variant="primary" 
                        onClick = {this.onBack}
                            style={{
                            width: "100%"
                            }}>
                        RETOUR
                </Button>
                </FormControl>
                
                </Flex>
                </Container>

            </Container>
        );
    }

    /**
     * FUNCTIONS
     */

    decodeHtmlCharCodes(str) { 
        
        return str.replace(/(&(rsquo);)/gi, "'");
      }

    
    //Back Event
    onBack = () =>  {
        

        eventBus.dispatch("event_infoview_close", {   event_infoview_close: true });

        
    }

    

}
export default EventInfoView;

